import create from 'zustand';
import { getCashInfo } from '../api/balance';
import { CashInfoResponse } from '../types/api/balance';

interface Action {
  loadCashInfo(symbol: string, orderId?: string): Promise<CashInfoResponse>;
  resetCashInfo(): Promise<void>;
}

interface State {
  tradingBalance: number;
  tradingLimit: number;
  dayTrade: number;
  dayTradeLeverage: number;
  dayTradeTradingBalance: number;
  isLoading: boolean;
  error: Error;
}

const initialState: State = {
  tradingBalance: null,
  tradingLimit: null,
  dayTrade: null,
  dayTradeLeverage: null,
  dayTradeTradingBalance: null,
  isLoading: false,
  error: null,
};

const useCashInfoStore = create<State & Action>((set) => ({
  ...initialState,
  loadCashInfo: async (symbol, orderId) => {
    try {
      set({
        tradingBalance: 0,
        tradingLimit: 0,
        dayTrade: 0,
        isLoading: true,
        error: null,
      });
      const axiosResponse = await getCashInfo(symbol, orderId);
      const { data } = axiosResponse.data;
      set({
        tradingBalance: Number(data.trade_balance),
        tradingLimit: Number(data.trade_limit),
        dayTrade: Number(data.day_trade_buying_power),
        dayTradeLeverage: Number(data.day_trade_leverage),
        dayTradeTradingBalance: Number(data.day_trade_trading_balance),
      });
      set({ isLoading: false });
      return data;
    } catch (e) {
      set({ isLoading: false, error: e });
      return Promise.reject(e);
    }
  },
  resetCashInfo: async () => {
    set(initialState);
  },
}));

export default useCashInfoStore;
